<!-- 应用页面入口 -->
<template>
  <div class="app-wrapper">
    <navbar></navbar>
    <app-menu
      class="menu-container"
      :style="{ width: menuBarWidth + 'px' }"
    ></app-menu>
    <div
      class="main-container"
      :style="{
        marginLeft: isCollapse ? menuBarWidth + 20 + 'px' : menuBarWidth + 'px'
      }"
    >
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { AppMain, AppMenu, Navbar } from './components'
export default {
  components: {
    AppMain,
    AppMenu,
    Navbar
  },
  data () {
    return {}
  },
  computed: {
    menuBarWidth () {
      return this.$store.state.app.menuBarWidth
    },
    isCollapse () {
      return this.$store.state.app.isCollapse
    }
  },
  watch: {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/layout';
</style>
